import { Pipe, PipeTransform } from '@angular/core';
import { FLOW_DATE_FORMAT } from '@core/constants';
import { Moment } from 'moment';
import { SessionQuery } from '../../../_core/state/session/session.query';

@Pipe({
    name: 'moment',
    standalone: false
})
export class MomentPipe implements PipeTransform {
    constructor(private sessionQuery: SessionQuery) {
    }

    transform(value: Moment, format?: string): string | Moment {
        if (value?.isValid()) {
            const userLanguage = this.sessionQuery.getValue().language;
            const translatedMoment = value.clone().locale(userLanguage);

            if (format) {
                return translatedMoment.format(format);
            }
            return translatedMoment.format(FLOW_DATE_FORMAT);
        }

        return value;
    }

}
